import React, { useEffect, useState } from "react";
import EmptyState from "components/EmptyState";
import { observer } from "mobx-react-lite";
import Retool from "react-retool";
import { retoolStore } from "store/RetoolStore";
import { IS_CONCULAR_ONE } from "utils";
import { useNavigate } from "react-router";
import clsx from "clsx";

interface EmbededApp {
  url: string;
  embeddedData: object;
  className?: string;
}

const retoolEnv = import.meta.env.VITE_RETOOL_ENV || "production";
const retoolShowUnpublished = import.meta.env
  .VITE_RETOOL_SHOW_UNPUBLISHED_VERSION;

export default observer(function EmbedApp(props: EmbededApp) {
  const [url, setUrl] = useState("");
  const [messagePayload, setMessagePayload] = useState({});
  const [urlPayload, setUrlPayload] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    async function getUrl() {
      setUrl("");
      const data = await retoolStore.getEmbedUrl(
        props.url,
        retoolEnv,
        retoolShowUnpublished ? "latest" : undefined
      );
      setUrl(data.embedUrl);
    }
    getUrl();
  }, [props.embeddedData]);

  function Loading() {
    return IS_CONCULAR_ONE ? null : (
      <EmptyState type="table" loading containerClassName="m-6" />
    );
  }

  function handleRetoolMessage(payload: never) {
    if (payload && payload["action"] == "redirect" && payload["value"]) {
      navigate(payload["value"], { replace: true });
    }
    if (payload && payload["action"] == "open_app" && payload["value"]) {
      async function replaceEmbeddedRetoolApp() {
        const data = await retoolStore.getEmbedUrl(
          payload["value"],
          retoolEnv,
          retoolShowUnpublished ? "latest" : undefined
        );
        setUrl(data.embedUrl);
        setMessagePayload(payload["payload"]);
        setUrlPayload(payload["url_payload"]);
      }
      replaceEmbeddedRetoolApp();
    }
  }

  let embedURL = url;
  if (urlPayload) {
    const searchParams = new URLSearchParams(urlPayload);
    embedURL = `${embedURL}${encodeURIComponent("&")}${encodeURIComponent(
      searchParams.toString()
    )}`;
  }

  return (
    <div className={clsx("h-[calc(100vh-64px)]", props.className)}>
      {embedURL ? (
        <Retool
          url={embedURL}
          data={{
            ...props.embeddedData,
            env: import.meta.env.VITE_ENV,
            ...messagePayload,
          }}
          onData={handleRetoolMessage}
        />
      ) : (
        Loading()
      )}
    </div>
  );
});
